import gql from 'graphql-tag';

const CREATE_PLACE = gql`
  mutation createPlace($data: CreatePlaceInput!) {
    createPlace(data: $data) {
      id
      street
      city
      state
      zipCode
      countryId
      country {
        id
        name
      }
      name
      workspaceId
      coordinate
    }
  }
`;

const UPDATE_PLACE_BY_ID = gql`
  mutation updatePlaceById($id: ID!, $data: UpdatePlaceInput) {
    updatePlaceById(id: $id, data: $data) {
      id
      street
      city
      state
      zipCode
      countryId
      country {
        id
        name
      }
      name
      workspaceId
      coordinate
    }
  }
`;

const DELETE_PLACE_BY_ID = gql`
  mutation DeletePlaceById($placeId: ID!) {
    deletePlaceById(id: $placeId) {
      id
      street
      zipCode
      city
      state
      country {
        name
        id
      }
      countryId
      name
      workspaceId
      coordinate
    }
  }
`;

export default {
  CREATE_PLACE,
  UPDATE_PLACE_BY_ID,
  DELETE_PLACE_BY_ID,
};
